'use es6';

import performanceNow from 'feedback-web-renderer-ui/vendor/performanceNow/performanceNow';
const emptyFunction = () => {};
export default (() => {
  let callback = emptyFunction;
  const updateRoute = pathname => {
    const timestamp = performanceNow();
    callback({
      pathname,
      timestamp
    });
  };
  const onListen = newCallback => {
    callback = newCallback;
    return () => {
      callback = emptyFunction;
    };
  };
  const rhumbHistory = pathname => ({
    listen: onListen,
    pathname
  });
  return {
    rhumbHistory,
    updateRoute
  };
});